/* eslint-disable max-len */
const Plus = ({ colorTheme }: { colorTheme: string }) => {

  const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<g clip-path="url(#clip0_13815_24848)">
<rect width="24" height="24" rx="4" fill="${colorTheme}"/>
<g clip-path="url(#clip1_13815_24848)">
<g clip-path="url(#clip2_13815_24848)">
<path d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z" fill="${colorTheme}"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.7504 8.00049C12.7504 7.58628 12.4147 7.25049 12.0004 7.25049C11.5862 7.25049 11.2504 7.58628 11.2504 8.00049V11.2499H8.00098C7.58677 11.2499 7.25098 11.5857 7.25098 11.9999C7.25098 12.4141 7.58677 12.7499 8.00098 12.7499H11.2504V15.9994C11.2504 16.4136 11.5862 16.7494 12.0004 16.7494C12.4147 16.7494 12.7504 16.4136 12.7504 15.9994V12.7499H15.9999C16.4141 12.7499 16.7499 12.4141 16.7499 11.9999C16.7499 11.5857 16.4141 11.2499 15.9999 11.2499H12.7504V8.00049Z" fill="white"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_13815_24848">
<rect width="24" height="24" rx="4" fill="white"/>
</clipPath>
<clipPath id="clip1_13815_24848">
<rect width="24" height="24" fill="white"/>
</clipPath>
<clipPath id="clip2_13815_24848">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
    `;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export default Plus;
